export default [
  {
    title: "Email",
    text: "suport@chedratax.ro",
  },
  {
    title: "Telefon",
    text: "0754 689 944",
  },
  {
    title: "Fax",
    text: "fax@chedratax.ro",
  },
  {
    title: "Website",
    text: "www.chedratax.ro",
  },
]
